(() => {
  const MAP_SELECTOR = '[data-contact-map]';
  const POINT_SELECTOR = '[data-contact-map-point]';
  const MAP_STYLE = 'https://tiles.openfreemap.org/styles/positron';
  const LIBRARY_RETRY_LIMIT = 20;

  const getPoints = (container) =>
    Array.from(container.querySelectorAll(POINT_SELECTOR))
      .map((point) => ({
        latitude: Number.parseFloat(point.dataset.latitude),
        longitude: Number.parseFloat(point.dataset.longitude),
        label: point.dataset.label || 'Warehouse',
      }))
      .filter((point) => Number.isFinite(point.latitude) && Number.isFinite(point.longitude));

  const addMarker = (map, point) => {
    const marker = document.createElement('span');
    marker.className = 'contact-map__marker';
    marker.setAttribute('role', 'img');
    marker.setAttribute('aria-label', point.label);
    marker.title = point.label;

    new window.maplibregl.Marker({ element: marker, anchor: 'center' })
      .setLngLat([point.longitude, point.latitude])
      .addTo(map);
  };

  const initializeMap = (container) => {
    if (container.dataset.mapInitialized === 'true' || !window.maplibregl) return;

    const points = getPoints(container);
    if (!points.length) {
      container.classList.add('is-error');
      const fallback = container.querySelector('.contact__map-fallback');
      if (fallback) fallback.textContent = 'Map location is unavailable.';
      return;
    }

    container.dataset.mapInitialized = 'true';

    let map;

    try {
      map = new window.maplibregl.Map({
        container,
        style: MAP_STYLE,
        center: [points[0].longitude, points[0].latitude],
        zoom: points.length === 1 ? 12 : 3,
        attributionControl: false,
        cooperativeGestures: true,
        dragRotate: false,
        pitchWithRotate: false,
      });
    } catch (error) {
      container.classList.add('is-error');
      const fallback = container.querySelector('.contact__map-fallback');
      if (fallback) fallback.textContent = 'Map is unavailable. Please use the location link below.';
      return;
    }

    container.classList.add('is-initialized');

    map.addControl(new window.maplibregl.NavigationControl({ showCompass: false }), 'top-right');
    map.addControl(new window.maplibregl.AttributionControl({ compact: true }), 'bottom-right');
    map.scrollZoom.disable();

    points.forEach((point) => addMarker(map, point));

    if (points.length > 1) {
      const bounds = points.reduce(
        (mapBounds, point) => mapBounds.extend([point.longitude, point.latitude]),
        new window.maplibregl.LngLatBounds()
      );
      map.fitBounds(bounds, { padding: 46, maxZoom: 12, duration: 0 });
    }

    map.once('load', () => {
      container.classList.add('is-ready');
      map.resize();
    });

    container.contactWarehouseMap = map;
  };

  const initializeMaps = (root = document) => {
    root.querySelectorAll(MAP_SELECTOR).forEach(initializeMap);
  };

  const waitForMapLibrary = (root = document, attempt = 0) => {
    if (window.maplibregl) {
      initializeMaps(root);
      return;
    }

    if (attempt >= LIBRARY_RETRY_LIMIT) {
      root.querySelectorAll(MAP_SELECTOR).forEach((container) => {
        container.classList.add('is-error');
        const fallback = container.querySelector('.contact__map-fallback');
        if (fallback) fallback.textContent = 'Map is unavailable. Please use the location link below.';
      });
      return;
    }

    window.setTimeout(() => waitForMapLibrary(root, attempt + 1), 250);
  };

  const destroyMaps = (root) => {
    root.querySelectorAll(MAP_SELECTOR).forEach((container) => {
      if (container.contactWarehouseMap) {
        container.contactWarehouseMap.remove();
        delete container.contactWarehouseMap;
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => waitForMapLibrary());
  } else {
    waitForMapLibrary();
  }

  document.addEventListener('shopify:section:load', (event) => waitForMapLibrary(event.target));
  document.addEventListener('shopify:section:unload', (event) => destroyMaps(event.target));
})();
